/* template */
<template><div class="container"><div :class="(clipContentClassName)" class="clip-content"><div :class="(chooseGalleryClassName)" class="upload-container choose-gallery"><es-navbar title="人证核验"></es-navbar><div class="es-clip-tips"><div class="es-clip-title">温馨提示</div><div class="es-clip-content">请上传一张五官清晰的正面照片</div></div><div class="es-clip-image"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/S04vGSwGcn1644303137714.png" mode="scaleToFill" class="es-clip-image-mode"></mpx-image></div><div class="upload-pretty"><mpx-view @tap="chooseImages" class="es-chooseImages-input">上传照片</mpx-view></div></div><div class="es-img-clip"><div class="img-clip"></div></div><div :class="(clipActionClassName)" class="clip-action nav-bar nav-bar-tab"><div class="es-nav-tip-text">3:4</div><mpx-view id="btn-reload" @tap="btnReload" class="tab-item es-btn-reload"><div class="mui-icon mui-icon-arrowleft tab-icon "><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/ZZEsmc940p1642476352407.png" class="es-icon-arrowleft"></mpx-image></div></mpx-view><mpx-view id="btn-rotate-clockwise" @tap="btnRotateAnticlockwise" class="tab-item btn-rotate-clockwise"><div class="mui-icon mui-icon-refreshempty tab-icon"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/alQ28bxblq1644324118136.png" class="es-roate-clockwise-icon"></mpx-image></div></mpx-view><mpx-view id="btn-verify" @tap="btnVerify" class="tab-item es-btn-verify"><div class="mui-icon mui-icon-checkmarkempty tab-icon"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/tBOkzhgQan1642476892674.png" class="es-icon-arrowleft"></mpx-image></div></mpx-view></div></div></div></template>

/* styles */
<style lang="stylus" src="./clip.styl" mpxStyleOptions='{"mid":"m5bd640be"}'>
</style>
<style lang="stylus" mpxStyleOptions='{"mid":"m5bd640be"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-chooseImages-input
    width 190px
    border-radius 0.5em
    color #ffffff
    border none
    background #1473ff
    padding 0
    margin 0 auto
    text-align center
    padding 13px 0px 15px 0px
    font-size 16px
  .black
    height 100%
    background #000000
  .es-input-upload
    width 200px
    height 60px
  .hidden
    display none !important
  .es-clip-image
    display flex
    justify-content center
    padding 20px 0
  .es-clip-image-mode
    width 172px
    height 172px
  .es-img-clip
    position absolute
    left 0
    top 0
    margin 0 auto
    padding 0
    width 100%
    height 100%
    background #000000
    z-index 1
  .img-clip
    position relative
    width 97%
    margin 0 auto
    padding 0
    background #000000
    z-index 1
  .img-clip canvas
    display block
  .img-clip-b1
    width 100%
    height 1px
    background rgba(255, 255, 255, 0.6)
  .img-clip .magnifier
    position absolute
    top -90px
    right 0
    /**
     * 显示的值，真实的宽高内部会设置
     */
    width 80px
    height 80px
    border-radius 50%
    border 2px solid #ffffff
  .img-clip .clip-hidden
    display none
  .img-clip .clip-rect
    position absolute
    border 1px solid rgba(255, 255, 255, 0.6)
    top 10px
    left 10px
    width 100px
    height 100px
    cursor move
    box-shadow 0 0px 2px rgba(0, 0, 0, 0.4)
    min-width 45px !important
  .img-clip-reat-left
    width 0px
    height 100%
    position absolute
    left 0px
    top 0px
    display none
    // border-top 1px solid rgba(255, 255, 255, 0.6)
    border-left 1px solid rgba(255, 255, 255, 0.6)
  .img-clip .clip-rect .clip-tips
    position absolute
    top -40px
    left 0
    padding 5px
    font-size 13px
    background-color $train-color-333
    border-radius 5px
    color #ffffff
  .img-clip .clip-rect-horn
    position absolute
    display block
    // background-color rgba(222, 60, 80, 0.7)
    // border-radius 50%
    width 30px
    height 30px
    // background #000
  .img-clip .clip-rect-horn:after
    content ' '
    position absolute
    width 25px
    height 2px
    background #ffffff
    top -3px
    left -3px
  .img-clip .clip-rect-horn:before
    content ' '
    position absolute
    width 2px
    height 25px
    background #ffffff
    top -3px
    left -3px
  .img-clip .horn-n
    top -10px
    left 50%
    margin-left -10px
    cursor n-resize
    display none
  .img-clip .horn-s
    bottom -10px
    left 50%
    margin-left -10px
    cursor s-resize
    display none
  .img-clip .horn-w
    top 50%
    left -10px
    margin-top -10px
    cursor w-resize
    display none
  .img-clip .horn-e
    top 50%
    right -10px
    margin-top -10px
    cursor e-resize
    display none
  .img-clip .horn-nw
    top 0px
    left 0px
    cursor nw-resize
  .img-clip .horn-ne
    top 0px
    right 0px
    cursor ne-resize
  .img-clip .horn-ne:after
    left 7px
    top -3px
  .img-clip .horn-ne:before
    left 30px
    top -2px
  .img-clip .horn-sw
    bottom 0px
    left 0px
    cursor sw-resize
  .img-clip .horn-sw:after
    left -3px
    top 31px
  .img-clip .horn-sw:before
    left -3px
    top 6px
  .img-clip .horn-se
    bottom -10px
    right -10px
    cursor se-resize
  .img-clip .horn-se:after
    left -3px
    top 21px
  .img-clip .horn-se:before
    left 20px
    top -3px
  .es-clip-tips
    width 252px
    margin 0 auto
    text-align center
    padding-top 30px
    font-size 16px
  .upload-container
    position relative
    height 100%
    z-index 2
    background #ffffff
  .hiddenBox
    display none
  .clip-tips-b1
    position absolute
    width 100%
    height 1px
    background rgba(255, 255, 255, 0.2)
    top 33.3%
  .clip-tips-b2
    position absolute
    width 100%
    height 1px
    background rgba(255, 255, 255, 0.2)
    top 66.3%
  .clip-tips-b3
    position absolute
    width 1px
    height 100%
    top 0
    background rgba(255, 255, 255, 0.2)
    left 33.3%
  .clip-tips-b4
    position absolute
    width 1px
    height 100%
    top 0
    background rgba(255, 255, 255, 0.2)
    left 66.3%
  .btn-rotate-clockwise
    width 32px
    height 32px
    position absolute
    right 50%
    top 0px
    margin-right -16px
  .es-roate-clockwise-icon
    width 32px
    height 32px
  .es-btn-reload
    width 40px
    height 40px
    position absolute
    left 30px
    top 0px
  .es-btn-verify
    width 40px
    height 40px
    position absolute
    right 30px
    top -2px
  .es-icon-arrowleft
    width 40px
    height 40px
  .es-nav-tip-text
    position absolute
    left 50%
    top -40px
    color #ffffff
    font-size 16px
    margin-left -10px
    font-family sans-serif
  .es-clip-title
    font-size 18px
    font-weight bold
  .es-clip-content
    font-size 16px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5bd640be"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex5bd640be%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex5bd640be%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5bd640be"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index5bd640be/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
